var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2667 0.405333C10.9012 0.142227 10.4568 0 10 0C9.54322 0 9.09876 0.142227 8.73333 0.405333L1.34444 5.72533C1.08225 5.91411 0.869446 6.1589 0.722876 6.44031C0.576306 6.72173 0.5 7.03204 0.5 7.34667V16.9733C0.5 17.5108 0.72242 18.0263 1.11833 18.4064C1.51424 18.7865 2.05121 19 2.61111 19H6.72778C7.03572 19 7.33106 18.8826 7.54881 18.6735C7.76656 18.4645 7.88889 18.181 7.88889 17.8853V12.92C7.88889 12.3825 8.11131 11.867 8.50722 11.4869C8.90313 11.1069 9.4401 10.8933 10 10.8933C10.5599 10.8933 11.0969 11.1069 11.4928 11.4869C11.8887 11.867 12.1111 12.3825 12.1111 12.92V17.8853C12.1111 18.181 12.2334 18.4645 12.4512 18.6735C12.6689 18.8826 12.9643 19 13.2722 19H17.3889C17.9488 19 18.4858 18.7865 18.8817 18.4064C19.2776 18.0263 19.5 17.5108 19.5 16.9733V7.34667C19.5 7.03204 19.4237 6.72173 19.2771 6.44031C19.1306 6.1589 18.9177 5.91411 18.6556 5.72533L11.2667 0.405333Z",
    fill: "#5AB2AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeVerde);
export default __webpack_public_path__ + "static/media/HomeVerde.7cad599e0f4d64447cd761b5f7ea5354.svg";
export { ForwardRef as ReactComponent };